<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="dedication" id="ded">
<p class="nonindent">To all the <em>Essential Poems</em> team</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062031716_epub_ded_r1.vue?97cff688